(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inbox-whatsapp-chat"] && !Shopify.designMode) return;
  try {
    (function () {
    var css =
      '.activator-nudge{bottom:17px!important}.activator-nudge.activator-nudge--right{right:0!important}' +
      'button.activator{background:#c9b48c!important;color:#1a1a1a!important;width:75px!important;height:75px!important;min-width:75px!important;min-height:75px!important;max-width:75px!important;max-height:75px!important;border-radius:8px 0 0 8px!important;display:flex;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:2px!important;padding:8px!important;overflow:hidden!important}' +
      ':host([open]) .activator{display:none}' +
      'button.activator:hover:not(:active){background:#bea87a!important}' +
      'button.activator .activator__icon{display:flex!important;align-items:center;justify-content:center;width:36px!important;height:36px!important;margin:0!important;flex:0 0 auto!important}' +
      'button.activator .activator__icon svg{width:36px!important;height:36px!important;display:block!important}' +
      'button.activator .activator__label{display:block!important;width:100%!important;margin:0!important;color:#1a1a1a!important;font-size:10px!important;line-height:1.1!important;font-weight:500!important;text-align:center!important;pointer-events:none!important}';

    var iconSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100" height="100" data-fj-chat-icon>' +
      '<path d="M14 14 h44 a8 8 0 0 1 8 8 v24 a8 8 0 0 1 -8 8 h-28 l-10 10 v-10 h-6 a8 8 0 0 1 -8 -8 v-24 a8 8 0 0 1 8 -8 z" fill="#2b2b2b"/>' +
      '<path d="M42 40 h40 a8 8 0 0 1 8 8 v22 a8 8 0 0 1 -8 8 h-6 v10 l-10 -10 h-24 a8 8 0 0 1 -8 -8 v-22 a8 8 0 0 1 8 -8 z" fill="#1a1a1a"/>' +
      '<circle cx="54" cy="59" r="3.2" fill="#fff"/>' +
      '<circle cx="66" cy="59" r="3.2" fill="#fff"/>' +
      '<circle cx="78" cy="59" r="3.2" fill="#fff"/>' +
      '</svg>';

    function findActivatorIcon() {
      var icon = null;

      function walk(root) {
        if (!root || icon) return;
        icon = root.querySelector('.activator__icon');
        if (icon) return;
        var nodes = root.querySelectorAll('*');
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].shadowRoot) walk(nodes[i].shadowRoot);
        }
      }

      document.querySelectorAll('shopify-chat').forEach(function (el) {
        walk(el.shadowRoot);
      });
      return icon;
    }

    function applyInbox() {
      var icon = findActivatorIcon();
      if (!icon) return false;
      var shadow = icon.getRootNode();

      if (!icon.querySelector('[data-fj-chat-icon]')) icon.innerHTML = iconSvg;

      var button = shadow.querySelector('button.activator') || icon.closest('button');
      if (button) {
        var outside = button.nextElementSibling;
        if (outside && outside.classList.contains('activator__label')) outside.remove();

        var label = button.querySelector('.activator__label');
        if (!label) {
          var nodes = button.querySelectorAll('span, p, div');
          for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            if (
              node.classList.contains('activator__icon') ||
              node.closest('.activator__icon') ||
              node.querySelector('.activator__icon')
            )
              continue;
            label = node;
            label.classList.add('activator__label');
            break;
          }
        }
        if (!label) {
          label = document.createElement('span');
          label.className = 'activator__label';
          button.appendChild(label);
        }
        if (label.textContent !== 'How can we help?') label.textContent = 'How can we help?';
      }

      if (!shadow.querySelector('style[data-chat-activator]')) {
        var style = document.createElement('style');
        style.setAttribute('data-chat-activator', '');
        style.textContent = css;
        shadow.appendChild(style);
      }

      return true;
    }

    function attachInbox(host) {
      var shadow = host.shadowRoot;
      if (!shadow) return;
      var pending = false;

      function restyle() {
        if (!host.isConnected || host.hasAttribute('open')) return;
        if (applyInbox() || pending) return;
        pending = true;
        var tries = 0;
        var timer = setInterval(function () {
          tries += 1;
          if (!host.isConnected || host.hasAttribute('open') || applyInbox() || tries > 20) {
            clearInterval(timer);
            pending = false;
          }
        }, 50);
      }

      restyle();
      new MutationObserver(restyle).observe(host, { attributes: true, attributeFilter: ['open'] });
      new MutationObserver(restyle).observe(shadow, { childList: true, subtree: true });
    }

    function watchInbox(host) {
      if (!host || host.dataset.fjInbox) return;
      if (host.shadowRoot) {
        host.dataset.fjInbox = '1';
        attachInbox(host);
        return;
      }

      host.dataset.fjInbox = 'wait';
      var tries = 0;
      var timer = setInterval(function () {
        if (!host.isConnected) {
          clearInterval(timer);
          return;
        }
        if (host.shadowRoot) {
          clearInterval(timer);
          host.dataset.fjInbox = '1';
          attachInbox(host);
          return;
        }
        tries += 1;
        if (tries > 40) {
          clearInterval(timer);
          delete host.dataset.fjInbox;
        }
      }, 50);
    }

    function findInbox() {
      document.querySelectorAll('shopify-chat').forEach(watchInbox);
    }

    findInbox();
    new MutationObserver(findInbox).observe(document.documentElement, { childList: true, subtree: true });

    // WhatsApp Chat

    var chat = document.querySelector('.wa-sticky .sticky-chat');
    if (!chat) return;
    var wa = chat.closest('.wa-sticky');
    var menu = wa.querySelector('.chat-menu');
    var overlay = wa.querySelector('.wa-overlay');

    var hideTimer;

    function syncOverlay(open) {
      clearTimeout(hideTimer);
      if (open) {
        chat.style.display = 'block';
        overlay.style.display = 'block';
        overlay.style.opacity = '0';
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
        hideTimer = setTimeout(function () {
          overlay.style.opacity = '1';
          chat.style.opacity = '1';
          chat.style.visibility = 'visible';
          chat.style.bottom = '90px';
        }, 10);
        return;
      }
      overlay.style.opacity = '0';
      overlay.style.backgroundColor = 'rgba(0, 0, 0, 0)';
      chat.style.opacity = '0';
      chat.style.visibility = 'hidden';
      chat.style.bottom = '70px';
      hideTimer = setTimeout(function () {
        if (!menu.checked) {
          overlay.style.display = 'none';
          chat.style.display = 'none';
        }
      }, 300);
    }

    menu.addEventListener('change', function () {
      syncOverlay(menu.checked);
    });
    overlay.addEventListener('click', function () {
      menu.checked = false;
      menu.dispatchEvent(new Event('change'));
    });
    document.addEventListener('click', function (event) {
      if (!menu.checked || wa.contains(event.target)) return;
      menu.checked = false;
      menu.dispatchEvent(new Event('change'));
    });
    var form = chat.querySelector('form');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var text = form.querySelector('input').value.trim();
      var url = new URL(chat.getAttribute('data-wa-url'));
      if (text) url.searchParams.set('text', text);
      window.open(url.toString(), '_blank');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
